import styled from 'styled-components'

import { Flex } from '@/ui/atoms/flex'
import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

export const VipSellerSectionWrapper = styled.div(
  ({ theme }) => `
  background: ${theme.colors.purple.light5};
  border-radius: ${theme.borderRadius.medium};
  box-shadow: ${theme.boxShadow['shadow-4']};
  display: grid;
  justify-content: center;
  margin-top: ${theme.spacing.default};
  padding: ${theme.spacing.default} ${theme.spacing.husky};
  
  ${MEDIA_QUERIES(theme).medium}{
    grid-template-columns: 1fr 1fr;
  }
  `
)

export const VipSellerStatusContainer = styled.div(
  ({ theme }) => `
  border-bottom: .1rem solid ${theme.colors.grey.light3};
  padding-bottom: ${theme.spacing.default};
  
  ${MEDIA_QUERIES(theme).medium}{
    padding-right: ${theme.spacing.husky};
    border-right: .1rem solid ${theme.colors.grey.light3};
    border-bottom: none;
  }
`
)

export const VipSellerMetricsContainer = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, 1fr auto);
`

export const VipSellerMetricItem = styled.li(
  ({ theme }) => `
  background-color: ${theme.colors.white};
  padding: 1.6rem 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column
`
)

export const VipSellerPromoteContainer = styled(Flex)(
  ({ theme }) => `
  padding-top: ${theme.spacing.default};
  
  ${MEDIA_QUERIES(theme).medium}{
    padding-left: ${theme.spacing.husky};
  }
`
)

// eslint-disable-next-line @kijiji/prefer-button-component
export const VipSellerPromoteLearnMoreButton = styled.button`
  align-items: center;
  display: flex;

  & > svg {
    height: 2.4rem;
    width: 2.4rem;
  }
`
